import { LiveMonitorItem } from "api/generatedApi";
import { IMonitor } from "interfaces/monitor.interface";
import { IZone } from "interfaces/zone.interface";

export type LiveDataTableProps = {
  zone: string;
  data: IMonitor[];
  path: string[];
};

export function groupData(
  zones: IZone[],
  selectedZones: IZone[],
  data: LiveMonitorItem[],
): LiveDataTableProps[] {
  const result: { [key: string]: LiveMonitorItem[] } = {};

  data.forEach((item) => {
    if (item.zone.id in result) {
      result[item.zone.id] = [...result[item.zone.id], item];
    } else {
      result[item.zone.id] = [item];
    }
  });

  return (selectedZones ?? []).map((zone) => ({
    zone: zone.id,
    path: zone.path
      .split(".")
      .map((id) => zones.find((zone) => zone.id === id)?.name)
      .filter((zone) => zone !== undefined),
    data: result[zone.id] ?? [],
  }));
}
